import { $t } from '@previo/core'
import { Codebook } from '../Codebook'

export enum WorkingPositionId {
  CONFERENCE = 1,
  OWNER = 2,
  DIRECTOR = 3,
  OPERATIONS_MANAGER = 4,
  SALES_MANAGER = 5,
  REVENUE_MANAGER = 6,
  FRONT_OFFICE_MANAGER = 7,
  RECEPTION = 8,
  MARKETING_MANAGER = 9,
}

export class ContactPersonWorkingPosition extends Codebook<WorkingPositionId> {
  private constructor(
    id: WorkingPositionId,
    public readonly name: () => string,
  ) {
    super(id)
  }

  static readonly CONFERENCE = new ContactPersonWorkingPosition(WorkingPositionId.CONFERENCE, () =>
    $t('Conference'),
  )
  static readonly OWNER = new ContactPersonWorkingPosition(WorkingPositionId.OWNER, () =>
    $t('Owner'),
  )
  static readonly DIRECTOR = new ContactPersonWorkingPosition(WorkingPositionId.DIRECTOR, () =>
    $t('Director'),
  )
  static readonly OPERATIONS_MANAGER = new ContactPersonWorkingPosition(
    WorkingPositionId.OPERATIONS_MANAGER,
    () => $t('Operations manager'),
  )
  static readonly SALES_MANAGER = new ContactPersonWorkingPosition(
    WorkingPositionId.SALES_MANAGER,
    () => $t('Sales manager'),
  )
  static readonly REVENUE_MANAGER = new ContactPersonWorkingPosition(
    WorkingPositionId.REVENUE_MANAGER,
    () => $t('Revenue manager'),
  )
  static readonly FRONT_OFFICE_MANAGER = new ContactPersonWorkingPosition(
    WorkingPositionId.FRONT_OFFICE_MANAGER,
    () => $t('Front office manager'),
  )
  static readonly RECEPTION = new ContactPersonWorkingPosition(WorkingPositionId.RECEPTION, () =>
    $t('Reception'),
  )
  static readonly MARKETING_MANAGER = new ContactPersonWorkingPosition(
    WorkingPositionId.MARKETING_MANAGER,
    () => $t('Marketing manager'),
  )
}
